(function () {
    'use strict';

    angular
        .module('app.campaignActivity', [])
        .factory('campaignActivityService', ['$q', '$http', '$rootScope', 'campaignConsts',
            function ($q, $http, $rootScope, campaignConsts) {
                var service = {};

                var campaignStatuses = [{
                    value: 1,
                    name: campaignConsts.Statuses.DECLINED
                }, {
                    value: 2,
                    name: campaignConsts.Statuses.INVITED
                }, {
                    value: 3,
                    name: campaignConsts.Statuses.ACCEPTED
                }, {
                    value: 4,
                    name: campaignConsts.Statuses.PUBLISHED
                }, {
                    value: 5,
                    name: campaignConsts.Statuses.INTERESTED
                }];

                function handleRequest(url, method, params, loader) {
                    var deferred = $q.defer();
                    var req = {
                        url: url,
                        method: method,
                        data: JSON.stringify(params),
                        loader: loader
                    }

                    $http(req).success(function (response) {
                        deferred.resolve(response);
                    }).error(function (error) {
                        deferred.reject(error);
                    });

                    return deferred.promise;
                }

                function getCampaignInfluencerDetail(campaign_influencer_id) {
                    return handleRequest($rootScope.apiUrl + 'campaign/getCampaignInfluencerDetail/' + campaign_influencer_id, 'GET', null, true);
                }

                function getCampaignInfluencerKPIs(campaign_influencer_id) {
                    return handleRequest($rootScope.apiUrl + 'campaign/getCampaignInfluencerKPIs/' + campaign_influencer_id, 'GET', null, true);
                }

                function getCampaignInfluencerPosts(campaign_influencer_id) {
                    return handleRequest($rootScope.apiUrl + 'campaign/getCampaignInfluencerPosts/' + campaign_influencer_id, 'GET', null, true);
                }

                function getCampaignActivities(campaign_influencer_id) {
                    return handleRequest($rootScope.apiUrl + 'campaign/getCampaignActivities/' + campaign_influencer_id, 'GET', null, true);
                }

                function addNote(data) {
                    return handleRequest($rootScope.apiUrl + 'campaign/addNote', 'POST', data, true);
                }

                function deleteInfluencerFromCampaign(campaign_influencer_id, loader){
                    var url = $rootScope.apiUrl + 'campaign/deleteInfluencerFromCampaign/' + campaign_influencer_id;
                    return handleRequest(url, 'DELETE', null, loader);
                }

                function changeCampaignInfluencerStatus(json, loader){
                    var url = $rootScope.apiUrl + 'campaign/updateInfluencerStatus';
                    return handleRequest(url, 'POST', json, loader);
                }

                return {
                    getCampaignInfluencerDetail: getCampaignInfluencerDetail,
                    getCampaignInfluencerKPIs: getCampaignInfluencerKPIs,
                    getCampaignInfluencerPosts: getCampaignInfluencerPosts,
                    getCampaignActivities: getCampaignActivities,
                    campaignStatuses: campaignStatuses,
                    addNote: addNote,
                    deleteInfluencerFromCampaign: deleteInfluencerFromCampaign,
                    changeCampaignInfluencerStatus: changeCampaignInfluencerStatus
                }
            }
        ]);
})();
